import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@core/auth/auth.guard';
import { SearchComponent } from './search.component';

const routes: Routes = [   
  {
    path: '',
    component: SearchComponent ,
    canActivate:[AuthGuard]  
  }  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SearchRoutingModule { }
